import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {connect} from "react-redux";

import {getPriceWithCurrency} from "../../../misc/helpers";


const ContractsPopupFieldValue = (props) => {

  const {field, fieldCoords, userState, fabricatorSettings, assignQuotePopupEmployee, grandTotal, depositValue} = props;
  const {userInfo} = userState;

  const getFieldDiv = (value) => {
    return (
      <div
        data-name={field.name}
        className={'contract-body__value'}
        style={fieldCoords}>
        {value}
      </div>
    )
  }

  switch (field.name) {
    case "firstName":
    case "lastName":
    case "email":
      return getFieldDiv(userInfo[field.name]);
    case "customerFullAddress":
      return getFieldDiv(userInfo["address1"]);
    case "zipCode":
      return getFieldDiv(userInfo["postal"]);
    case "phone":
      return getFieldDiv(userInfo["phoneNumber"]);
    case "jobId":
      return getFieldDiv(document.kvConfig.jobId);
    case "salesPerson": {
      let employeeSelected = null;
      if (userInfo.employeeId && userState.employeesListReceived) {
        employeeSelected = userState.employeesList.find(emp => +emp.id === +userInfo.employeeId)
      } else {
        employeeSelected = assignQuotePopupEmployee;
      }
      return getFieldDiv(employeeSelected ? employeeSelected.fullName : "");
    }
    case "signatureDate":
      // return getFieldDiv(moment().format('MM/DD/YYYY h:mma'));
      return getFieldDiv(moment().format('MM/DD/YYYY'));
    case "price": {
      const withCurrency = getPriceWithCurrency(fabricatorSettings, grandTotal.toFixed(2));
      return getFieldDiv(withCurrency)
    }
    case "deposit": {
      return getFieldDiv(getPriceWithCurrency(fabricatorSettings, depositValue.toFixed(2)));
    }
    case "balance": {
      const balance = (grandTotal - depositValue).toFixed(2);
      const withCurrency = getPriceWithCurrency(fabricatorSettings, balance);
      return getFieldDiv(withCurrency)
    }
    case "custom":
    case "checkbox":
    case "signature":
    default:
      return null
  }
};

// ["costcoExclusiveMembers"] = quoteFeatures.Any(f => f.Group == "Costco Member Benefits" && f.Name.Contains("Costco Executive Members") && f.Quantity > 0) ? costco2Precents.ToString("0.00") : "0.00",
//   ["costcoShopCard"] = costcoShopCard.ToString("0.00"),
//   ["costcoCitiVisa"] = quoteFeatures.Any(f => f.Group == "Costco Member Benefits" && f.Name.Contains("Costco Citi Visa Cardholder") && f.Quantity > 0) ? costco2Precents.ToString("0.00") : "0.00",

ContractsPopupFieldValue.propTypes = {
  field: PropTypes.object,
  fieldCoords: PropTypes.object,
  totalPrice: PropTypes.object,
}

const mapStateToProps = (store) => {
  const userState = store.userState;
  const {assignQuotePopupEmployee} = store.assignQuoteState;
  const fabricatorSettings = store.fabricatorState.settings;
  return {
    assignQuotePopupEmployee,
    userState,
    fabricatorSettings,
  };
};

export default connect(mapStateToProps)(ContractsPopupFieldValue)
